<template>
  <div class="flex items-center">
    <img
      height="57"
      width="57"
      src="../assets/bot-avatar.svg"
      class="mr-4"
    >
    <div>
      <div class="mb-2 font-extrabold">{{ title }}</div>
      <div>{{ subtitle }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseFormHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
};
</script>
